import {
    createSecondResource,
    deleteSecondResource,
    getSecondResource,
    getSecondResourceSilent,
    updateSecondResource
} from "../actions/secondResource";

export const getSecondDataSelect = ({ dispatch, user }) => ({ query, resource }) =>
    dispatch(getSecondResource({
        user,
        query,
        resource
    }));

export const getSecondDataSilentSelect = ({ dispatch, user }) => ({ query, resource }) =>
    dispatch(getSecondResourceSilent({
        user,
        query,
        resource
    }));

export const createSecondDataSelect = ({ dispatch, user }) => (object) =>
    dispatch(createSecondResource({
        user,
        ...object
    }));

export const updateSecondDataSelect = ({ dispatch, user }) => (object) =>
    dispatch(updateSecondResource({
        user,
        ...object
    }));

export const deleteSecondDataSelect = ({ dispatch, user }) => (object) =>
    dispatch(deleteSecondResource({
        user,
        ...object
    }));